import { css } from "@emotion/css";
import { BorderRadius, Colors, FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

export const pageContent = css`
    margin-top: 21px;
    padding: ${Spacing.MD}px ${Spacing.LG}px ${Spacing.LG}px ${Spacing.LG}px;
    background: ${Colors.WHITE};
    border-radius: ${BorderRadius.container}px;
`;

export const createLensSpaceButton = css`
    margin-top: ${Spacing.LG}px;
`;

export const sectionHeader = css`
    margin-right: 9.5px;
    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.MEDIUM};
    color: ${Colors.Black.V50};
`;

export const sectionMargin = css`
    margin-bottom: ${Spacing.MD}px;
`;

export const sectionHeaderMargin = css`
    margin-bottom: ${Spacing["2XS"]}px;
`;

export const buttonLinkContainer = css`
    margin-top: ${Spacing.XS}px;
    margin-bottom: ${Spacing.XS}px;
`;
